import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { UserEntity } from 'ha/types/UserEntity';
import { Check1Bold } from '@ha/icons';
import { units, Divider, Grid, Typography } from '@hbf/dsl';

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.txb(0, 1, 1),
  },
  title: {
    marginBottom: units.rem(1),
  },
  section: {
    marginBottom: units.rem(0.5),
  },
  checkIcon: {
    fontSize: units.rem(0.75),
  },
  divider: {
    marginBottom: units.rem(0.5),
  },
}));

interface Props {
  user: UserEntity;
}

const UserCardVerificationsWithCheckmarks: React.FC<Props> = ({ user }) => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <section className={classes.root}>
      <Typography.Caption
        data-test-locator="Identity Verified"
        fontWeight="bold"
        className={classes.title}
      >
        {T('Verification')}
      </Typography.Caption>

      {user.isKYCDone && (
        <div>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.section}
          >
            <Typography.Caption data-test-locator="Identity Verified">
              {T('identity')}
            </Typography.Caption>
            <Check1Bold className={classes.checkIcon} color="secondary" />
          </Grid>

          {(user.hasPhone ||
            user.isEmailVerified ||
            user.hasFacebookProfile) && <Divider className={classes.divider} />}
        </div>
      )}

      {user.hasPhone && (
        <div>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.section}
          >
            <Typography.Caption data-test-locator="User Card Phone Verified">
              {T('Phone number')}
            </Typography.Caption>
            <Check1Bold className={classes.checkIcon} color="secondary" />
          </Grid>

          {(user.isEmailVerified || user.hasFacebookProfile) && (
            <Divider className={classes.divider} />
          )}
        </div>
      )}

      {user.isEmailVerified && (
        <div>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.section}
          >
            <Typography.Caption data-test-locator="User Card Email Verified">
              {T('E-mail address')}
            </Typography.Caption>
            <Check1Bold className={classes.checkIcon} color="secondary" />
          </Grid>

          {user.hasFacebookProfile && <Divider className={classes.divider} />}
        </div>
      )}

      {user.hasFacebookProfile && (
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography.Caption data-test-locator="User Card Facebook Connected">
            {T('Facebook connected')}
          </Typography.Caption>
          <Check1Bold className={classes.checkIcon} color="secondary" />
        </Grid>
      )}
    </section>
  );
};

export { UserCardVerificationsWithCheckmarks };
